import { Box, IconButton, Stack, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

export const taskDialogPaperSx = {
  borderRadius: "20px",
  overflow: "hidden",
  maxHeight: "92vh",
  boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
};

export const compactFieldSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "10px",
    fontSize: 14,
    "&:not(.MuiInputBase-multiline)": { minHeight: 42 },
  },
  "& .MuiInputLabel-root": { fontSize: 14 },
};

export const primaryActionSx = {
  minWidth: 124,
  px: 2.5,
  borderRadius: "10px",
  textTransform: "none",
  fontWeight: 700,
};

export const secondaryActionSx = {
  ...primaryActionSx,
  bgcolor: "transparent",
};

export function TaskPageHeader({ onBack }) {
  return (
    <Stack direction="row" sx={{ alignItems: "center", justifyContent: "space-between" }}>
      <IconButton
        onClick={onBack}
        aria-label="Volver a Recursos Humanos"
        sx={{
          width: 36,
          height: 36,
          bgcolor: "secondary.500",
          "&:hover": { bgcolor: "secondary.600" },
        }}
      >
        <ArrowBackIcon sx={{ color: "logoblanco", fontSize: 32 }} />
      </IconButton>
      <Stack sx={{ flex: 1, alignItems: "center", pr: "48px" }}>
        <Box
          sx={{
            px: 2.5,
            py: 1.1,
            bgcolor: "secondary.200",
            borderRadius: "33px",
            boxShadow: "inset 0px 0px 3px rgba(142, 142, 159, 0.5)",
          }}
        >
          <Typography sx={{ fontSize: 18, fontWeight: 600, color: "primary.900" }}>
            Tareas
          </Typography>
        </Box>
      </Stack>
    </Stack>
  );
}

export function TaskModuleShell({ children }) {
  return (
    <Box
      sx={{
        p: { xs: 1.5, sm: 2 },
        bgcolor: "rgba(255,255,255,0.86)",
        borderRadius: "20px",
        border: "1px solid rgba(255,255,255,0.9)",
        boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
        width: "100%",
        minWidth: 0,
        boxSizing: "border-box",
      }}
    >
      {children}
    </Box>
  );
}
